// @flow

import type {
  ContactUsOperation,
  ContactUsOperator,
} from '../types'

import operator from './operator'

// Module Export Type
type ContactUsReducers = { [string]: (state: Object, payload: ContactUsOperation) => Object }

// Reducers
function cancelOperation (state: Object): Object {
  return {
    ...state,
    contactUsOperation: [],
  }
}

function addOperation (state: Object, payload: ContactUsOperation): Object {
  return {
    ...state,
    contactUsOperation: payload,
  }
}

function updateOperation (state: Object, payload: ContactUsOperation): Object {
  if (state.ContactUsOperation) {
    return {
      ...state,
      contactUsOperation: {
        ...payload,
        model: {
          ...state.ContactUsOperation.model,
          ...payload.model,
        },
      },
    }
  } else {
    return {
      ...state,
      contactUsOperation: payload,
    }
  }
}

export default function composeAccountReducer (): ContactUsReducers {
  const contactUsOperator: ContactUsOperator = operator()

  return {
    [contactUsOperator.actionTypes.add()]: addOperation,
    [contactUsOperator.actionTypes.updateOperation()]: updateOperation,
    [contactUsOperator.actionTypes.cancelOperation()]: cancelOperation,
  }
}
